"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AAPIClient_1 = __importDefault(require("./AAPIClient"));
const PUSHTypes_1 = require("../PUSHTypes");
const AAPITypes_1 = require("./AAPITypes");
const SubscribeMarketInformation_1 = require("./calls/SubscribeMarketInformation");
const SubscribeEventHierarchy_1 = require("./calls/SubscribeEventHierarchy");
const SubscribeCustomHierarchy_1 = require("./calls/SubscribeCustomHierarchy");
const SubscribeFixedOddsMarketPrices_1 = require("./calls/SubscribeFixedOddsMarketPrices");
const SubscribeDetailedMarketPrices_1 = require("./calls/SubscribeDetailedMarketPrices");
const SubscribeMarketMatchedAmounts_1 = require("./calls/SubscribeMarketMatchedAmounts");
class AAPIExchangeClient extends AAPIClient_1.default {
    constructor(params) {
        super(params);
        this._subscribedExchangeSelection = {};
        this._subscribedExchangeMarket = {};
        this._subscribedExchangeEvent = {};
        this._subscribedExchangeEventTaggedValue = {};
        this._subscribedExchangeMarketTaggedValue = {};
        this._subscribedExchangeEventTabs = {};
        this._exchangeEventTabs = {};
        this._regexArrayLocal = [
            {
                regex: /(\d{1,4})\/D\S10$/,
                method: this._onSubscribeDetailedMarketPrices,
                converter: {
                    0: 'correlationId',
                    1: 'returnCode',
                    2: 'subscriptionId',
                    3: 'marketIds',
                    4: 'availableMarketsCount',
                },
            },
            {
                regex: /(\d{1,4})\/D\S14$/,
                method: this._onSubscribeMarketMatchedAmounts,
                converter: {
                    0: 'correlationId',
                    1: 'returnCode',
                    2: 'subscriptionId',
                    3: 'marketIds',
                    4: 'availableMarketsCount',
                },
            },
            {
                regex: /(\d{1,4})\/D\S12$/,
                method: this._onSubscribeEventHierarchy,
                converter: {
                    0: 'correlationId',
                    1: 'returnCode',
                    2: 'subscriptionId',
                    4: 'availableMarketsCount',
                },
            },
            {
                regex: /(\d{1,4})\/D\S11$/,
                method: this._onSubscribeFixedOddsMarketPrices,
                converter: {
                    0: 'correlationId',
                    1: 'returnCode',
                    2: 'subscriptionId',
                    3: 'marketIds',
                    4: 'availableMarketsCount',
                },
            },
            {
                regex: /^\S(\d{1,4})\/D\S9$/,
                method: this._onSubscribeMarketInformation,
                converter: {
                    0: 'correlationId',
                    1: 'returnCode',
                    2: 'subscriptionId',
                    3: 'marketIds',
                },
            },
            {
                regex: /^.*\/E\/E_([0-9]*)\/M\/E_([0-9]*)$/,
                method: this._onMarket1,
                converter: {
                    1: 'displayOrder',
                    2: [{ 1: 'occurredAt', 2: 'score' }],
                },
            },
            {
                regex: /^.*\/M\/E_([0-9]+)\/MEI\/MEL\/([a-z\d\--]{2})$/,
                method: this._onLanguage3,
                converter: { 1: 'name', 2: 'description', 3: 'marketBlurb' },
            },
            {
                regex: /^.*\/M\/E_([0-9]*)\/ML\/([a-z\d\--]{2})$/,
                method: this._onLanguage7,
                converter: {
                    1: 'name',
                },
            },
            {
                regex: /^.*\/M\/E_([0-9]*)\/MEI\/MDP\/(\d\d?)_(\d\d?)_(\d*)_([A-Z]{3})_([1-3])$/,
                method: this._onBackLayVolumeCurrencyOddsFormat,
                converter: {
                    1: [
                        {
                            1: 'selectionId',
                            2: [{ 1: 'displayPrice', 2: 'stake' }],
                            3: [{ 1: 'displayPrice', 2: 'stake' }],
                            4: 'redboxDisplayPrice',
                            5: 'redboxFractionalPrice',
                        },
                    ],
                },
            },
            {
                regex: /^.*\/M\/E_([0-9]*)\/MEI\/FO\/([A-Z]{1})$/,
                method: this._onFixedOddsMarketPrices,
                converter: { 1: [{ 1: 'selectionId', 2: 'price' }] },
            },
            {
                ///BrokerId/Events/Event1/EventLanguage/Language4
                regex: /^.*\/E\/E_([0-9]*)\/EL\/([a-z\d\--]{2})$/,
                method: this._onLanguage4,
                converter: {
                    1: 'name',
                },
            },
            {
                regex: /^.*\/E\/E_([0-9]*)$/,
                method: this._onEvent1,
                converter: {
                    1: 'displayOrder',
                    2: [{ 1: 'occurredAt', 2: 'score' }],
                    3: [{ 1: 'occurrenceType', 2: 'predictedTime', 3: 'actualTime' }],
                },
            },
            {
                regex: /^.*\/E\/E_([0-9]*)\/EEI$/,
                method: this._onEExchangeInfo,
                converter: {
                    1: 'eventClassifierId',
                    2: 'isEnabledForMultiples',
                    3: 'startTime',
                },
            },
            {
                regex: /^.*\/E\/E_([0-9]*)\/EEI\/EEL\/([a-z\d\--]{2})$/,
                method: this._onLanguage2,
                converter: {
                    1: 'name',
                    2: 'raceGrade',
                },
            },
            {
                regex: /^.*\/M\/E_([0-9]*)\/MEI$/,
                method: this._onMExchangeInfo,
                converter: {
                    1: 'marketId',
                    2: 'marketType',
                    3: 'isPlayMarket',
                    4: 'canBeInRunning',
                    5: 'managedWhenInRunning',
                    6: 'isVisibleAsTradingMarket',
                    7: 'isVisibleAsPricedMarket',
                    8: 'isEnabledForMultiples',
                    9: 'isCurrentlyInRunning',
                    10: 'status',
                    11: 'withdrawAction',
                    12: 'ballotOutAction',
                    13: 'canBeDeadHeated',
                    14: 'startTime',
                    15: 'delayFactor',
                    16: 'numberOfWinningSelections',
                    17: 'withdrawalSequenceNumber',
                    18: 'resultString',
                    19: 'numberOfSelections',
                    20: 'placePayout',
                    21: 'redboxSPAvailable',
                    22: 'bOGAvailable',
                    23: 'numberWinningPlaces',
                    24: 'placeFraction',
                    25: 'bettingTypeId',
                },
            },
            {
                regex: /^.*\/S\/E_([0-9]+)\/SEI$/,
                method: this._onSExchangeInfo,
                converter: {
                    1: 'selectionId',
                    2: 'status',
                    3: 'selectionResetCount',
                    4: 'withdrawalFactor',
                    5: 'settledTime',
                    6: 'resultString',
                    7: 'voidPercentage',
                    8: 'leftSideFactor',
                    9: 'rightSideFactor',
                    10: 'redboxSelection',
                },
            },
            {
                regex: /^.*\/S\/E_([0-9]+)\/SEI\/SB$/,
                method: this._onSelectionblurb,
                converter: { 1: 'selectionBlurb' },
            },
            {
                regex: /^.*\/M\/E_([0-9]+)\/S\/E_([0-9]*)\/SEI\/SEL\/([a-z\d\--]{2})$/,
                method: this._onLanguage6,
                converter: { 1: 'name', 2: 'selectionBlurb' },
            },
            {
                regex: /^.*\/M\/E_([0-9]+)\/S\/E_([0-9]+)$/,
                method: this._onSelection1,
                converter: { 1: 'displayOrder', 2: 'selectionIcon' },
            },
            {
                regex: /^.*\/M\/E_([0-9]+)\/S\/E_([0-9]+)\/SL\/[a-z\d\--]{2}$/,
                method: this._onLanguage5,
                converter: { 1: 'name' },
            },
            {
                regex: /^.*\/E\/E_([0-9]*)\/EEI\/TAB\/Tab(\d*)$/,
                method: this._onTab,
                converter: {
                    1: 'displayOrder',
                    2: 'marketIds',
                    3: 'numberOfMarketsToExpand',
                },
            },
            {
                regex: /^.*\/E\/E_([0-9]*)\/EEI\/TAB\/Tab(\d*)\/TL\/([a-z\d\--]{2})$/,
                method: this._onLanguage14,
                converter: {
                    1: 'name',
                },
            },
            {
                regex: /^.*\/E\/E_([0-9]*)\/TV\/(.*)$/,
                method: this._onTaggedValue1,
                converter: {
                    1: 'value',
                },
            },
            {
                regex: /^.*\/M\/E_([0-9]*)\/TV\/(.*)$/,
                method: this._onTaggedValue2,
                converter: {
                    1: 'value',
                },
            },
        ];
        this.subscribeMarketInformation = SubscribeMarketInformation_1.subscribeMarketInformation.bind(this);
        this.subscribeEventHierarchy = SubscribeEventHierarchy_1.subscribeEventHierarchy.bind(this);
        this.subscribeCustomHierarchy = SubscribeCustomHierarchy_1.subscribeCustomHierarchy.bind(this);
        this.subscribeFixedOddsMarketPrices = SubscribeFixedOddsMarketPrices_1.subscribeFixedOddsMarketPrices.bind(this);
        this.subscribeDetailedMarketPrices = SubscribeDetailedMarketPrices_1.subscribeDetailedMarketPrices.bind(this);
        this.subscribeMarketMatchedAmounts = SubscribeMarketMatchedAmounts_1.subscribeMarketMatchedAmounts.bind(this);
        this._fixedOddsChangedDelegates = {};
        this._priceChangedDelegates = {};
        //private _subscribedExchangeSelectionMatchedAmounts: {
        //  [key: string]: SubscribedExchangeSelectionMatchedAmount;
        //} = {};
        this._subscribedExchangeSelectionFixedOddsPrices = {};
        this._marketPrices = {};
        this._subscribedExchangeSelectionIndexedPrices = {};
        this.extendRegex(this._regexArrayLocal);
    }
    getCachedMarket(marketId) {
        return this._subscribedExchangeMarket[marketId];
    }
    getCachedEvent(eventId) {
        return this._subscribedExchangeEvent[eventId];
    }
    getCachedEventTaggedValue(eventId) {
        return this._subscribedExchangeEventTaggedValue[eventId];
    }
    getCachedMarketTaggedValue(marketId) {
        return this._subscribedExchangeMarketTaggedValue[marketId];
    }
    getCachedEventclassifier(eventId) {
        return this._subscribedExchangeEvent[eventId];
    }
    getCachedTabs(eventId) {
        const tabs = [];
        for (const t in this._subscribedExchangeEventTabs[eventId]?.tabs) {
            tabs.push(this._subscribedExchangeEventTabs[eventId].tabs[t]);
        }
        return tabs.sort((a, b) => {
            return a.displayOrder > b.displayOrder ? 1 : -1;
        });
    }
    getCachedExchangePrice(selectionId) {
        return this._subscribedExchangeSelectionIndexedPrices[selectionId];
    }
    getCachedFixedOdds(selectionId) {
        return this._subscribedExchangeSelectionFixedOddsPrices[selectionId];
    }
    _onSubscribeMarketInformation({ bodyObject }) {
        const correlationId = bodyObject.correlationId, returnCode = bodyObject.returnCode, subscriptionId = bodyObject.subscriptionId;
        const correlationData = this._correlationData[correlationId];
        if (returnCode === 0) {
            const response = {
                subscriptionId,
                marketIds: bodyObject.marketIds
                    ? bodyObject.marketIds.split('~').map((x) => +x)
                    : [],
            };
            correlationData.callbackOnSuccess(response);
        }
        else {
            correlationData.callbackOnException(new PUSHTypes_1.AsyncException({ returnCode: returnCode }));
        }
    }
    _onSubscribeDetailedMarketPrices({ bodyObject }) {
        const correlationId = bodyObject.correlationId, returnCode = bodyObject.returnCode, subscriptionId = bodyObject.subscriptionId;
        const correlationData = this._correlationData[correlationId];
        // const correlationDataParams = this._correlationData[
        //   correlationId
        // ] as SubscribePricesParams;
        super.removeFromPushMessages(correlationId);
        if (returnCode == 0) {
            const response = {
                subscriptionId,
                marketIds: bodyObject.marketIds
                    ? bodyObject.marketIds.split('~').map((x) => +x)
                    : [],
            };
            correlationData.callbackOnSuccess(response);
        }
        else {
            correlationData.callbackOnException(new PUSHTypes_1.AsyncException({ returnCode: returnCode }));
        }
    }
    _onSubscribeMarketMatchedAmounts({ bodyObject }) {
        const correlationId = bodyObject.correlationId, returnCode = bodyObject.returnCode, subscriptionId = bodyObject.subscriptionId;
        const correlationData = this._correlationData[correlationId];
        super.removeFromPushMessages(correlationId);
        if (returnCode == 0) {
            const response = {
                subscriptionId,
                marketIds: bodyObject.marketIds
                    ? bodyObject.marketIds.split('~').map((x) => +x)
                    : [],
            };
            correlationData.callbackOnSuccess(response);
        }
        else {
            correlationData.callbackOnException.call(this, new PUSHTypes_1.AsyncException({ returnCode: returnCode }));
        }
    }
    _onSubscribeEventHierarchy({ bodyObject }) {
        const correlationId = bodyObject.correlationId, returnCode = bodyObject.returnCode, subscriptionId = bodyObject.subscriptionId;
        const correlationData = this._correlationData[correlationId];
        if (bodyObject.returnCode == 0) {
            correlationData.callbackOnSuccess({
                subscriptionId,
            });
        }
        else {
            correlationData.callbackOnException.call(this, new PUSHTypes_1.AsyncException({ returnCode: returnCode }));
        }
    }
    _onSubscribeFixedOddsMarketPrices({ bodyObject }) {
        const correlationId = bodyObject.correlationId, returnCode = bodyObject.returnCode, subscriptionId = bodyObject.subscriptionId;
        const correlationData = this._correlationData[correlationId];
        super.removeFromPushMessages(correlationId);
        if (returnCode == 0) {
            correlationData.callbackOnSuccess.call(this, {
                subscriptionId,
                marketIds: bodyObject.marketIds
                    ? bodyObject.marketIds.split('~').map((x) => +x)
                    : [],
            });
        }
        else {
            correlationData.callbackOnException.call(this, new PUSHTypes_1.AsyncException({ returnCode: returnCode }));
        }
    }
    getOrCreateSubscribedSelection(selectionId) {
        return (this._subscribedExchangeSelection[selectionId] =
            this._subscribedExchangeSelection[selectionId] ||
                new AAPITypes_1.SubscribedExchangeSelection());
    }
    getOrCreateSubscribedMarket(marketId) {
        if (this._subscribedExchangeMarket[marketId] == undefined) {
            this._subscribedExchangeMarket[marketId] = new AAPITypes_1.SubscribedExchangeMarket();
            this._subscribedExchangeMarket[marketId]._selectionIndex =
                this._subscribedExchangeSelection;
        }
        return this._subscribedExchangeMarket[marketId];
    }
    getOrCreateSubscribedEvent(eventId) {
        return (this._subscribedExchangeEvent[eventId] =
            this._subscribedExchangeEvent[eventId] || new AAPITypes_1.SubscribedExchangeEvent());
    }
    getOrCreateSubscribedEventTaggedValue(eventId) {
        return (this._subscribedExchangeEventTaggedValue[eventId] =
            this._subscribedExchangeEventTaggedValue[eventId] ||
                new AAPITypes_1.SubscribedExchangeEventTaggedValue());
    }
    getOrCreateSubscribedMarketTaggedValue(eventId) {
        return (this._subscribedExchangeMarketTaggedValue[eventId] =
            this._subscribedExchangeMarketTaggedValue[eventId] ||
                new AAPITypes_1.SubscribedExchangeMarketTaggedValue());
    }
    getOrCreateSubscribedEventTabs(eventId) {
        return (this._subscribedExchangeEventTabs[eventId] =
            this._subscribedExchangeEventTabs[eventId] ||
                new AAPITypes_1.SubscribedExchangeEventTab());
    }
    _onSExchangeInfo({ headerMatches, bodyObject }) {
        if (headerMatches === null) {
            return;
        }
        const selectionId = Number(headerMatches[1]);
        const thisSubscribedExchangeSelection = (this._subscribedExchangeSelection[selectionId] =
            this._subscribedExchangeSelection[selectionId] ||
                new AAPITypes_1.SubscribedExchangeSelection());
        //for (const k in bodyObject) {
        //  thisSubscribedExchangeSelection[k] = bodyObject[k];
        // }
        if (bodyObject.selectionId != undefined)
            thisSubscribedExchangeSelection.selectionId = Number(bodyObject.selectionId);
        if (bodyObject.selectionResetCount != undefined)
            thisSubscribedExchangeSelection.selectionResetCount = Number(bodyObject.selectionResetCount);
        if (bodyObject.status != undefined)
            thisSubscribedExchangeSelection.withdrawalFactor = Number(bodyObject.status);
        if (bodyObject.withdrawalFactor != undefined)
            //optional
            thisSubscribedExchangeSelection.withdrawalFactor = Number(bodyObject.withdrawalFactor);
        if (bodyObject.settledTime != undefined)
            //optional
            thisSubscribedExchangeSelection.settledTime =
                bodyObject.settledTime;
        if (bodyObject.resultString != undefined)
            //optional
            thisSubscribedExchangeSelection.resultString =
                bodyObject.resultString;
        if (bodyObject.voidPercentage != undefined)
            //optional
            thisSubscribedExchangeSelection.voidPercentage = Number(bodyObject.voidPercentage);
        if (bodyObject.leftSideFactor != undefined)
            //optional
            thisSubscribedExchangeSelection.leftSideFactor = Number(bodyObject.leftSideFactor);
        if (bodyObject.rightSideFactor != undefined)
            //optional
            thisSubscribedExchangeSelection.rightSideFactor = Number(bodyObject.rightSideFactor);
        thisSubscribedExchangeSelection.fireDeltaDelegates(bodyObject);
        // thisSubscribedExchangeSelection.prototype.fireILDelegates(gecPrivate._subscribedExchangeSelectionILDelegate);
        // if (!webClientMessage.isInitialTopicLoad()) {
        //     thisSubscribedExchangeSelection.prototype.fireDeltaDelegates(bodyObject);
        // }
    }
    _onSelectionblurb({ headerMatches, bodyObject }) {
        if (headerMatches === null) {
            return;
        }
        const selectionId = Number(headerMatches[1]);
        const thisSubscribedExchangeSelection = this.getOrCreateSubscribedSelection(selectionId);
        thisSubscribedExchangeSelection.fireDeltaDelegates(bodyObject);
        //for (const k in bodyObject) {
        //  thisSubscribedExchangeSelection[k] = bodyObject[k] as string;
        //}
    }
    _onEvent1({ headerMatches, bodyObject }) {
        if (headerMatches === null) {
            return;
        }
        const eventId = Number(headerMatches[1]), thisEvent = this.getOrCreateSubscribedEvent(eventId);
        thisEvent.displayOrder = Number(bodyObject.displayOrder);
        thisEvent.eventClassifierId = eventId;
        thisEvent.genericId = Number(eventId);
        thisEvent.fireDeltaDelegates(bodyObject);
        // thisEvent.prototype.fireILDelegates(gecPrivate._subscribedExchangeEventILDelegates);
    }
    _onLanguage2({ headerMatches, bodyObject }) {
        if (headerMatches === null) {
            return;
        }
        const eventId = Number(headerMatches[1]), thisEvent = this.getOrCreateSubscribedEvent(eventId);
        thisEvent.genericName = bodyObject.name;
        thisEvent.raceGrade = bodyObject.raceGrade;
        thisEvent.fireDeltaDelegates(bodyObject);
        //thisEvent.prototype.fireILDelegates(this._subscribedExchangeEventILDelegates);
        //thisEvent.prototype.fireDeltaDelegates({
        //  genericName: bodyObject.name,
        //  raceGrade: bodyObject.raceGrade
        // });
    }
    _onLanguage4({ headerMatches, bodyObject }) {
        if (headerMatches === null) {
            return;
        }
        const eventId = Number(headerMatches[1]), thisEvent = this.getOrCreateSubscribedEvent(eventId);
        thisEvent.name = bodyObject.name;
        thisEvent.fireDeltaDelegates(bodyObject);
        //thisEvent.prototype.fireILDelegates(this._subscribedExchangeEventILDelegates);
        //thisEvent.prototype.fireDeltaDelegates({
        //  name: bodyObject.name
        //});
    }
    _onLanguage6({ headerMatches, bodyObject }) {
        if (headerMatches === null) {
            return;
        }
        //const marketId = Number(headerMatches[1]);
        const selectionId = Number(headerMatches[2]);
        const thisSubscribedExchangeSelection = this.getOrCreateSubscribedSelection(selectionId);
        thisSubscribedExchangeSelection.name = bodyObject.name;
        thisSubscribedExchangeSelection.selectionBlurb =
            bodyObject.selectionBlurb;
        thisSubscribedExchangeSelection.fireDeltaDelegates(bodyObject);
    }
    _onSelection1({ headerMatches, bodyObject }) {
        if (headerMatches === null) {
            return;
        }
        const marketId = Number(headerMatches[1]);
        const selectionId = Number(headerMatches[2]);
        const thisSubscribedExchangeSelection = this.getOrCreateSubscribedSelection(selectionId);
        thisSubscribedExchangeSelection.displayOrder = Number(bodyObject.displayOrder);
        thisSubscribedExchangeSelection.marketId = marketId;
        if (bodyObject.selectionIcon !== undefined)
            thisSubscribedExchangeSelection.selectionIcon =
                bodyObject.selectionIcon;
        thisSubscribedExchangeSelection.fireDeltaDelegates(bodyObject);
    }
    _onLanguage5({ headerMatches, bodyObject }) {
        if (headerMatches === null) {
            return;
        }
        const selectionId = Number(headerMatches[2]);
        const thisSubscribedExchangeSelection = (this._subscribedExchangeSelection[selectionId] =
            this._subscribedExchangeSelection[selectionId] ||
                new AAPITypes_1.SubscribedExchangeSelection());
        thisSubscribedExchangeSelection.name = bodyObject.name;
        thisSubscribedExchangeSelection.fireDeltaDelegates(bodyObject);
    }
    _onMarket1({ headerMatches, bodyObject }) {
        if (headerMatches === null) {
            return;
        }
        const marketId = Number(headerMatches[2]), thisMarket = this.getOrCreateSubscribedMarket(marketId);
        thisMarket.genericId = marketId;
        thisMarket.displayOrder = Number(bodyObject.displayOrder);
        thisMarket.eventClassifierId = Number(headerMatches[1]);
        thisMarket.fireDeltaDelegates(bodyObject);
        //thisMarket.prototype.fireILDelegates(
        //  this._subscribedExchangeMarketILDelegates
        //);
    }
    _onLanguage3({ headerMatches, bodyObject }) {
        if (headerMatches === null) {
            return;
        }
        const marketId = Number(headerMatches[1]), thisMarket = this.getOrCreateSubscribedMarket(marketId);
        thisMarket.name = bodyObject.name;
        if (bodyObject.description != undefined)
            //optional
            thisMarket.description = bodyObject.description;
        if (bodyObject.marketBlurb != undefined)
            //optional
            thisMarket.marketBlurb = bodyObject.marketBlurb;
        thisMarket.fireDeltaDelegates(bodyObject);
        //if (!webClientMessage.isInitialTopicLoad() || hasChanges) {
        //  this._subscribedExchangeMarket[
        //    marketId
        //  ].prototype.fireDeltaDelegates(bodyObject);
        // }
    }
    _onLanguage7({ headerMatches, bodyObject }) {
        if (headerMatches === null) {
            return;
        }
        const marketId = Number(headerMatches[1]), thisMarket = this.getOrCreateSubscribedMarket(marketId);
        thisMarket.genericName = bodyObject.name;
        thisMarket.fireDeltaDelegates(bodyObject);
    }
    _onEExchangeInfo({ headerMatches, bodyObject }) {
        if (headerMatches === null) {
            return;
        }
        const eventId = Number(headerMatches[1]), thisEvent = this.getOrCreateSubscribedEvent(eventId);
        thisEvent.eventClassifierId = eventId;
        thisEvent.isEnabledForMultiples =
            bodyObject.isEnabledForMultiples;
        thisEvent.fireDeltaDelegates(bodyObject);
        //thisEvent.prototype.fireILDelegates(
        //  this._subscribedExchangeEventILDelegates
        //);
    }
    _onTab({ headerMatches, bodyObject }) {
        if (headerMatches === null) {
            return;
        }
        const eventId = Number(headerMatches[1]), tabId = Number(headerMatches[2]), thisEventTabs = this.getOrCreateSubscribedEventTabs(eventId);
        if (bodyObject.displayOrder !== undefined) {
            bodyObject.displayOrder = Number(bodyObject.displayOrder);
        }
        if (bodyObject.numberOfMarketsToExpand !== undefined) {
            bodyObject.numberOfMarketsToExpand = Number(bodyObject.numberOfMarketsToExpand);
        }
        if (bodyObject.marketIds !== undefined) {
            bodyObject.marketIds = bodyObject.marketIds
                .split('~')
                .map((x) => +x);
            const existingName = thisEventTabs.tabs[tabId]?.name || '';
            thisEventTabs.tabs[tabId] = {
                name: existingName,
                displayOrder: Number(bodyObject.displayOrder),
                numberOfMarketsToExpand: Number(bodyObject.numberOfMarketsToExpand),
                marketIds: bodyObject.marketIds,
            };
        }
        else {
            delete thisEventTabs.tabs[tabId];
        }
    }
    _onLanguage14({ headerMatches, bodyObject }) {
        if (headerMatches === null) {
            return;
        }
        const eventId = Number(headerMatches[1]), thisEventTabs = this.getOrCreateSubscribedEventTabs(eventId), tabId = Number(headerMatches[2]);
        thisEventTabs.tabs[tabId].name = bodyObject.name;
        // thisEventTabs.addTab(tabId, bodyObject);
    }
    _onTaggedValue1({ headerMatches, bodyObject }) {
        if (headerMatches === null) {
            return;
        }
        const eventId = Number(headerMatches[1]), taggedName = headerMatches[2], thisEventTaggedValue = this.getOrCreateSubscribedEventTaggedValue(eventId);
        thisEventTaggedValue.name = taggedName;
        thisEventTaggedValue.value = bodyObject.value;
        thisEventTaggedValue.fireDeltaDelegates(bodyObject);
        // thisEvent.taggedValues = thisEvent.taggedValues || {};
        //  thisEvent.taggedValues[taggedName] = bodyObject.value;
        //  thisEvent.prototype.fireILDelegates(
        //    gecPrivate._subscribedExchangeEventILDelegates
        //  );
        //  const changes = { taggedValues: {} };
        //  changes.taggedValues[taggedName] = bodyObject.value;
        //thisEvent.prototype.fireDeltaDelegates(changes);
    }
    _onTaggedValue2({ headerMatches, bodyObject }) {
        if (headerMatches === null) {
            return;
        }
        const marketId = Number(headerMatches[1]), thisMarketTaggedValue = this.getOrCreateSubscribedMarketTaggedValue(marketId), taggedName = headerMatches[2];
        thisMarketTaggedValue.name = taggedName;
        thisMarketTaggedValue.value = bodyObject.value;
        thisMarketTaggedValue.fireDeltaDelegates(bodyObject);
        // thisMarket.taggedValues = thisMarket.taggedValues || {};
        // thisMarket.taggedValues[taggedName] = bodyObject.value;
        /* thisMarket.prototype.fireILDelegates(
          gecPrivate._subscribedExchangeMarketILDelegates
        );
        const changes = { taggedValues: {} };
        changes.taggedValues[taggedName] = bodyObject.value;
    
        thisMarket.prototype.fireDeltaDelegates(changes);*/
    }
    _onMExchangeInfo({ headerMatches, bodyObject }) {
        if (headerMatches === null) {
            return;
        }
        const marketId = Number(headerMatches[1]), thisMarket = this.getOrCreateSubscribedMarket(marketId);
        let hasChanges = false;
        if ((bodyObject.status != null && thisMarket.status != bodyObject.status) ||
            (bodyObject.isCurrentlyInRunning != null &&
                thisMarket.isCurrentlyInRunning != bodyObject.isCurrentlyInRunning) ||
            (bodyObject.managedWhenInrunning != null &&
                thisMarket.managedWhenInrunning != bodyObject.managedWhenInrunning) ||
            (bodyObject.canBeInRunning != null &&
                thisMarket.canBeInRunning != bodyObject.canBeInRunning) ||
            (bodyObject.isEnabledForMultiples != null &&
                thisMarket.isEnabledForMultiples != bodyObject.isEnabledForMultiples)) {
            hasChanges = true;
        }
        bodyObject.numberOfSelections = Number(bodyObject.numberOfSelections);
        if (bodyObject.bettingTypeId !== undefined) {
            bodyObject.bettingTypeId = Number(bodyObject.bettingTypeId);
        }
        //for (let k:string in bodyObject) {
        //    thisMarket[k] = bodyObject[k];
        //}
        thisMarket.marketType = thisMarket.marketType * 1;
        thisMarket.displayOrder = thisMarket.displayOrder * 1;
        thisMarket.marketId = marketId;
        if (bodyObject.bOGAvailable !== undefined) {
            //optional
            thisMarket.bOGAvailable = bodyObject.bOGAvailable;
            hasChanges = true;
        }
        if (bodyObject.numberWinningPlaces != undefined) {
            //optional
            thisMarket.numberWinningPlaces = Number(bodyObject.numberWinningPlaces);
            hasChanges = true;
        }
        if (bodyObject.placeFraction !== undefined) {
            //optional
            thisMarket.placeFraction = Number(bodyObject.placeFraction);
            hasChanges = true;
        }
        if (bodyObject.startTime !== undefined) {
            //optional
            thisMarket.startTime = bodyObject.startTime;
        }
        if (bodyObject.delayFactor != undefined) {
            //optional
            thisMarket.delayFactor = Number(bodyObject.delayFactor);
        }
        //if (bodyObject.numberOfWinningSelections != undefined) {
        //optional
        //  thisMarket.numberOfWinningSelections = Number(
        //    bodyObject.numberOfWinningSelections
        //   );
        // }
        if (bodyObject.withdrawalSequenceNumber != undefined) {
            //optional
            thisMarket.withdrawalSequenceNumber = Number(bodyObject.withdrawalSequenceNumber);
        }
        if (bodyObject.resultString != undefined) {
            //optional
            thisMarket.resultString = bodyObject.resultString;
        }
        thisMarket.fireDeltaDelegates(bodyObject);
        //thisMarket.prototype.fireILDelegates(this._subscribedExchangeMarketILDelegates);
        //        if (!webClientMessage.isInitialTopicLoad() || hasChanges) {
        //          thisMarket.prototype.fireDelegates(this._subscribedExchangeMarketILDelegates, webClientMessage, bodyObject);
        //    }
    }
    _onFixedOddsMarketPrices({ 
    // webClientMessage,
    headerMatches, bodyObject, }) {
        if (headerMatches === null) {
            return;
        }
        const marketId = Number(headerMatches[1]);
        const priceFormatId = Number(headerMatches[2]);
        const selections = bodyObject[1];
        for (const i in selections) {
            const selectionInfo = selections[i];
            const selectionId = Number(selectionInfo.selectionId);
            const selectionPriceKey = selectionId + '_' + priceFormatId;
            //const price = selectionInfo.price as string;
            this._subscribedExchangeSelectionFixedOddsPrices[selectionPriceKey] = {
                backReferencePrice: selectionInfo.price,
                layReferencePrice: 'Not implemented',
                marketId,
                selectionId,
            };
            const isNewOrder = false;
            for (const subscriptionId in this._fixedOddsChangedDelegates) {
                if (isNewOrder) {
                    this._fixedOddsChangedDelegates[subscriptionId].onNewPrice(this._subscribedExchangeSelectionFixedOddsPrices[selectionPriceKey]);
                }
                else {
                    this._fixedOddsChangedDelegates[subscriptionId].onPriceChange(this._subscribedExchangeSelectionFixedOddsPrices[selectionPriceKey]);
                }
            }
            /*if (
              this._subscribedExchangeSelectionFixedOddsPrices[selectionPriceKey] ==
                null ||
              webClientMessage.isInitialTopicLoad()
            ) {
              this._subscribedExchangeSelectionFixedOddsPrices[
                selectionPriceKey
              ] = {};
            }*/
            //gecPrivate._subscribedExchangeSelectionFixedOddsPrices[selectionId] = gecPrivate._subscribedExchangeSelectionFixedOddsPrices[selectionId] || new gec.SubscribedExchangeSelectionFixedOddsPrices();
            //selectionPrices.selectionId = selectionId;
            //selectionPrices.marketId = marketId;
            // selectionPrices.backReferencePrice = price;
            //gecPrivate._subscribedExchangeSelectionFixedOddsPrices[selectionId].selectionId = layReferencePrice;
            /* selectionPrices.prototype.fireILDelegates(
              gecPrivate._subscribedExchangeSelectionFixedOddsPricesILDelegate
            );
      
            if (!webClientMessage.isInitialTopicLoad()) {
              gecPrivate._subscribedExchangeSelectionFixedOddsPrices[
                selectionPriceKey
              ].prototype.fireDeltaDelegates(
                gecPrivate._subscribedExchangeSelectionFixedOddsPrices[
                  selectionPriceKey
                ],
                bodyObject
              );
            }*/
        }
    }
    _onBackLayVolumeCurrencyOddsFormat({ webClientMessage, headerMatches, bodyObject, }) {
        if (headerMatches === null) {
            return;
        }
        const marketId = Number(headerMatches[1]);
        const marketByVolume = Number(headerMatches[4]);
        const currency = headerMatches[5];
        const priceFormatId = Number(headerMatches[6]);
        if (this._marketPrices[marketId] == null ||
            webClientMessage.isInitialTopicLoad()) {
            this._marketPrices[marketId] = {};
        }
        const selections = bodyObject[1];
        for (const i in selections) {
            const selectionInfo = selections[i];
            const selectionId = Number(selectionInfo.selectionId);
            const selectionPriceKey = `${selectionId}_${marketByVolume}_${currency}_${priceFormatId}`;
            const selectionPrices = (this._subscribedExchangeSelectionIndexedPrices[selectionPriceKey] = this._subscribedExchangeSelectionIndexedPrices[selectionPriceKey] || {
                layPrices: [],
                backPrices: [],
                marketId,
                selectionId,
            });
            //backprices
            if (selectionInfo[2] !== undefined) {
                selectionPrices.backPrices = this.mergeNewPrices(selectionPrices.backPrices, selectionInfo[2]).sort(function (a, b) {
                    //check if fractional
                    const aPrice = eval(a.displayPrice), bPrice = eval(b.displayPrice);
                    return aPrice < bPrice ? 1 : -1;
                });
            }
            //layprices
            if (selectionInfo[3] !== undefined) {
                selectionPrices.layPrices = this.mergeNewPrices(selectionPrices.layPrices, selectionInfo[3]).sort(function (a, b) {
                    //check if fractional
                    const aPrice = eval(a.displayPrice), bPrice = eval(b.displayPrice);
                    return aPrice > bPrice ? 1 : -1;
                });
            }
            const isNewOrder = false;
            for (const subscriptionId in this._priceChangedDelegates) {
                if (isNewOrder) {
                    this._priceChangedDelegates[subscriptionId].onNewPrice(this._subscribedExchangeSelectionIndexedPrices[selectionPriceKey]);
                }
                else {
                    this._priceChangedDelegates[subscriptionId].onPriceChange(this._subscribedExchangeSelectionIndexedPrices[selectionPriceKey]);
                }
            }
        }
    }
    mergeNewPrices(existingPriceArray, newPriceArray) {
        const priceIndex = {};
        for (const p in existingPriceArray) {
            priceIndex[existingPriceArray[p].displayPrice] =
                existingPriceArray[p].stake;
        }
        for (const i in newPriceArray) {
            const item = newPriceArray[i];
            const displayPrice = item.displayPrice;
            if (item.stake === undefined) {
                // delete
                delete priceIndex[displayPrice];
            }
            else {
                priceIndex[displayPrice] = Number(item.stake);
            }
        }
        const returnArray = [];
        for (const p in priceIndex) {
            returnArray.push({ displayPrice: p, stake: priceIndex[p] });
        }
        return returnArray;
    }
}
exports.default = AAPIExchangeClient;
